import React from 'react';
import DepartmentOverviewTopRow from '../portal/DepartmentOverviewTopRow';
import DepartmentWhatsNewCard from '../portal/DepartmentWhatsNewCard';
import DepartmentImplementationCard from '../portal/DepartmentImplementationCard';

const TECHNOLOGY_FALLBACK_SCHEDULE_URL =
  'https://calendly.com/ianr-lhxe/technology-strategy-call?hide_gdpr_banner=1';

const TechnologyAllTab = () => {
  return (
    <div>
      {/* Community · Roadmap (with current task) · Goals */}
      <DepartmentOverviewTopRow category="technology" />

      {/* What's New (left) · Implementation Hours (right) */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <DepartmentWhatsNewCard department="technology" />
        <DepartmentImplementationCard
          department="technology"
          fallbackScheduleUrl={TECHNOLOGY_FALLBACK_SCHEDULE_URL}
        />
      </div>
    </div>
  );
};

export default TechnologyAllTab;
